import SocialLoginButton from './SocialLoginButton';

export default SocialLoginButton;
